import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Popup } from '../Popup';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-20">{children}</main>
      <Footer />
      <Popup />
    </div>
  );
};
